import React from 'react';
import { AccommodationPlacePartnerV2 } from './AccommodationPlacePartnerV2';
import { AccommodationPlacePartnerV3 } from './AccommodationPlacePartnerV3';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { JoyLogoLoader } from '@shared/components/JoyLogoLoader';

const AccommodationPlacePartner = (props: { accommodationPlaceV2ByIdId: string }) => {
  const [accommodationsPriceAndRedirectEnabled, loadingPriceFlag] = useIsFeatureEnabled('accommodationsPriceAndRedirectEnabled');
  return (
    <>
      {loadingPriceFlag ? (
        <JoyLogoLoader loaderKey="guest-accommodation-place-v3" />
      ) : (
        <>{accommodationsPriceAndRedirectEnabled ? <AccommodationPlacePartnerV3 {...props} /> : <AccommodationPlacePartnerV2 {...props} />}</>
      )}
    </>
  );
};

export default AccommodationPlacePartner;
